const NWF_API_ENDPOINT = "https://nwf-generator.vercel.app/api/make-word";
const NWF_MUG_PRODUCT_URL = "/products/personalized-mug?variant=46818514075804%26nwf=preview%26nwf_cache=202605100100";
const NWF_OLD_MUG_NAME = /personalized mug/gi;
const NWF_NEW_MUG_NAME = "Nerd Word Mug";

function normalizeNwfProductName(root = document.body) {
  if (!root) return;

  const replaceMugName = value => String(value || "").replace(NWF_OLD_MUG_NAME, NWF_NEW_MUG_NAME);
  const hasOldMugName = value => /personalized mug/i.test(String(value || ""));

  if (document.title && hasOldMugName(document.title)) {
    document.title = replaceMugName(document.title);
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent) return NodeFilter.FILTER_REJECT;
      if (["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
      return hasOldMugName(node.nodeValue)
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    }
  });

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    node.nodeValue = replaceMugName(node.nodeValue);
  });

  ["aria-label", "title", "alt"].forEach(attribute => {
    root.querySelectorAll?.(`[${attribute}*="Personalized Mug" i]`).forEach(element => {
      element.setAttribute(attribute, replaceMugName(element.getAttribute(attribute)));
    });
  });
}

function observeNwfProductName() {
  normalizeNwfProductName();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (/personalized mug/i.test(node.nodeValue || "")) {
            node.nodeValue = node.nodeValue.replace(NWF_OLD_MUG_NAME, NWF_NEW_MUG_NAME);
          }
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE) normalizeNwfProductName(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

class WordFactory {
  constructor(root) {
    this.root = root;
    this.sectionId = root.id.replace("word-factory-", "");
    this.endpoint = root.dataset.apiEndpoint || NWF_API_ENDPOINT;
    this.authToken = root.dataset.apiToken || "";

    this.normalizeMarkup();

    this.elements = {
      who: this.findInput("who"),
      what: this.findInput("what", "moment"),
      vibe: this.findInput("vibe", "when"),
      statusText: root.querySelector(".wf-status-text"),
      resultWrap: root.querySelector(".wf-result"),
      word: root.querySelector("[data-word]"),
      description: root.querySelector("[data-description]") || root.querySelector("[data-definition]"),
      sampleSentence: root.querySelector("[data-sample-sentence]"),
      btnGenerate: root.querySelector('[data-action="generate"]'),
      btnPlaceWord: root.querySelector('[data-action="place-word"]'),
      btnReset: root.querySelector('[data-action="reset"]'),
      purchaseStep: root.querySelector("[data-nwf-purchase-step]"),
      mugSection: this.findMugSection()
    };

    if (!this.elements.btnGenerate) return;

    this.lastGenerated = null;
    this.elements.btnGenerate.addEventListener("click", () => this.generate());
    this.elements.btnReset?.addEventListener("click", () => this.reset());
    this.elements.btnPlaceWord?.addEventListener("click", () => this.placeWord());
    this.hideMugPurchaseStep();
  }

  findInput(...names) {
    for (const name of names) {
      const byName = this.root.querySelector(`input[name="${name}"], textarea[name="${name}"]`);
      if (byName) return byName;

      const byId = document.getElementById(`wf-${name}-${this.sectionId}`);
      if (byId && this.root.contains(byId)) return byId;
    }

    return null;
  }

  normalizeMarkup() {
    this.root.dataset.apiEndpoint = this.endpoint;
    this.normalizeInputCopy();

    const intro = this.root.querySelector(".wf-intro");
    if (intro) intro.textContent = "Give the who, moment, and vibe.";

    const card = this.root.querySelector(".wf-card");
    if (!card) return;

    card.innerHTML = `
      <dl class="wf-output-list">
        <div class="wf-output-row">
          <dt>New Word</dt>
          <dd class="wf-word" data-word>-</dd>
        </div>
        <div class="wf-output-row">
          <dt>Definition</dt>
          <dd class="wf-description" data-description data-definition>-</dd>
        </div>
        <div class="wf-output-row">
          <dt>Example</dt>
          <dd class="wf-sample-sentence" data-sample-sentence>-</dd>
        </div>
      </dl>

      <hr class="wf-divider">
      <div class="wf-actions">
        <button class="wf-btn wf-btn-primary" type="button" data-action="place-word">
          See Your Word on a Mug
        </button>
      </div>
      <div class="wf-product-selection" data-nwf-purchase-step hidden>
        <h4 class="wf-product-heading">OPENING YOUR MUG</h4>
        <div class="wf-product-grid">
          <a href="${NWF_MUG_PRODUCT_URL}" class="wf-product-link">
            <span class="wf-product-label">See Your Word on a Mug</span>
          </a>
        </div>
      </div>
    `;
  }

  normalizeInputCopy() {
    const who = this.findInput("who");
    const what = this.findInput("what", "moment");
    const vibe = this.findInput("vibe", "when");

    const setLabel = (input, text) => {
      if (!input?.id) return;
      const label = this.root.querySelector(`label[for="${input.id}"]`);
      if (label) label.textContent = text;
    };

    setLabel(who, "Who is this for?");
    setLabel(what, "What's the moment?");
    setLabel(vibe, "What's the vibe?");

    if (who) who.placeholder = "Maya and Roger";
    if (what) what.placeholder = "anniversary";
    if (vibe) {
      vibe.placeholder = "tender, sun drenched";
      vibe.name = "vibe";
      vibe.setAttribute("aria-label", "What's the vibe?");
    }
  }

  findProductListSections() {
    const sections = [];
    const wordFactorySection = this.root.closest(".shopify-section");
    if (!wordFactorySection) return sections;

    let nextSection = wordFactorySection.nextElementSibling;
    while (nextSection) {
      if (nextSection.querySelector('[data-testid="product-list"]')) sections.push(nextSection);
      nextSection = nextSection.nextElementSibling;
    }

    return sections;
  }

  findMugSection() {
    return document.querySelector("[data-nwf-mug-section]") ||
      document.querySelector("#nwf-mug-section") ||
      document.querySelector(".tib-product-form")?.closest(".shopify-section");
  }

  hideProductListSections() {
    this.findProductListSections().forEach(section => {
      section.style.display = "none";
    });
  }

  hideMugPurchaseStep() {
    this.root.classList.remove("nwf-word-placed");
    if (this.elements?.purchaseStep) this.elements.purchaseStep.hidden = true;
    if (this.elements?.mugSection) this.elements.mugSection.hidden = true;
    this.hideProductListSections();
  }

  showMugPurchaseStep() {
    this.root.classList.add("nwf-word-placed");
    document.body.classList.add("nwf-mug-flow");
    this.hideProductListSections();

    if (this.elements.purchaseStep) this.elements.purchaseStep.hidden = false;

    this.elements.mugSection = this.findMugSection();
    if (this.elements.mugSection) {
      this.elements.mugSection.hidden = false;
      this.elements.mugSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (this.elements.purchaseStep) {
      this.elements.purchaseStep.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  setStatus(text, loading = false) {
    if (this.elements.statusText) this.elements.statusText.textContent = text || "";
    this.root.classList.toggle("word-factory--loading", loading);
  }

  getPayload() {
    return {
      who: (this.elements.who?.value || "").trim(),
      what: (this.elements.what?.value || "").trim(),
      vibe: (this.elements.vibe?.value || "").trim()
    };
  }

  parseResult(result) {
    const item = result?.output?.forged?.[0] || result?.forged?.[0] || result || {};
    const word = String(item.word || item.newWord || item.new_word || "").trim();
    const description = this.formatDescription(item.description || item.definition || item.meaning);
    const sampleSentence = String(
      item.sampleSentence || item.sample_sentence || item.example || item.sentence || ""
    ).trim();

    return { word, description, sampleSentence };
  }

  formatDescription(value) {
    const text = String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^\*?verb\*?\.\s*/i, "")
      .replace(/^v\.\s*/i, "");

    return text ? `Verb. ${text}` : "";
  }

  saveGeneratedWord(inputs, generated) {
    const stored = {
      ...inputs,
      ...generated,
      newWord: generated.word,
      definition: generated.description,
      example: generated.sampleSentence
    };

    this.lastGenerated = stored;

    try {
      localStorage.setItem("nwf_word", generated.word);
      localStorage.setItem("nwf_description", generated.description || "");
      localStorage.setItem("nwf_definition", generated.description || "");
      localStorage.setItem("nwf_sample_sentence", generated.sampleSentence || "");
      localStorage.setItem("nwf_example", generated.sampleSentence || "");
      localStorage.setItem("nwf_meta", JSON.stringify(inputs));
      localStorage.setItem("nwf_generated", JSON.stringify(stored));
      localStorage.removeItem("nwf_pronunciation");
      localStorage.removeItem("nwf_origin");

      sessionStorage.setItem("nwf_generated", JSON.stringify(stored));
      sessionStorage.removeItem("nwf_pronunciation");
      sessionStorage.removeItem("nwf_origin");
    } catch (err) {
      console.warn("Unable to save generated Nerd Word data.", err);
    }

    window.dispatchEvent(new CustomEvent("nwf:wordGenerated", { detail: stored }));
  }

  clearGeneratedWord() {
    [
      "nwf_word",
      "nwf_pronunciation",
      "nwf_description",
      "nwf_definition",
      "nwf_origin",
      "nwf_sample_sentence",
      "nwf_example",
      "nwf_meta",
      "nwf_generated",
      "nwf_place_word",
      "nwf_checkout_after_add"
    ].forEach(key => {
      try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      } catch (err) {
        console.warn("Unable to clear Nerd Word data.", err);
      }
    });
  }

  renderResult(generated) {
    if (this.elements.word) this.elements.word.textContent = generated.word;

    if (this.elements.description) this.elements.description.textContent = generated.description || "";
    if (this.elements.sampleSentence) this.elements.sampleSentence.textContent = generated.sampleSentence || "";

    if (!this.elements.resultWrap) return;

    this.elements.resultWrap.hidden = false;
    this.elements.resultWrap.classList.remove("wf-result--show");
    this.elements.resultWrap.offsetWidth;
    this.elements.resultWrap.classList.add("wf-result--show");

    requestAnimationFrame(() => {
      this.elements.resultWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }

  async generate() {
    const inputs = this.getPayload();

    if (!inputs.who || !inputs.what || !inputs.vibe) {
      this.setStatus("Please fill in Who, Moment, and Vibe.", false);
      return;
    }

    this.elements.btnGenerate.disabled = true;
    this.setStatus("Making your word...", true);
    this.hideMugPurchaseStep();

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 25000);

    try {
      const response = await fetch(this.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inputs),
        signal: controller.signal
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => "");
        throw new Error(errorText || `Request failed: ${response.status}`);
      }

      const generated = this.parseResult(await response.json().catch(() => ({})));
      if (!generated.word) throw new Error("No word returned from API.");

      this.saveGeneratedWord(inputs, generated);
      this.renderResult(generated);
      this.setStatus("Your word is ready.", false);
    } catch (err) {
      console.error("Word Factory error:", err);
      const message = err.name === "AbortError"
        ? "The word maker took too long. Please try again."
        : "Error generating your word. Please try again.";
      this.setStatus(message, false);
    } finally {
      window.clearTimeout(timeout);
      this.elements.btnGenerate.disabled = false;
    }
  }

  placeWord() {
    if (!this.lastGenerated) {
      this.setStatus("Make your word first.", false);
      return;
    }

    try {
      localStorage.setItem("nwf_place_word", "1");
      sessionStorage.setItem("nwf_place_word", "1");
      localStorage.setItem("nwf_checkout_after_add", "1");
    } catch (err) {
      console.warn("Unable to mark Nerd Word as placed.", err);
    }

    window.dispatchEvent(new CustomEvent("nwf:placeWord", { detail: this.lastGenerated }));
    this.showMugPurchaseStep();
    this.setStatus("Opening your mug preview...", false);
    window.location.assign(NWF_MUG_PRODUCT_URL);
  }

  reset() {
    if (this.elements.who) this.elements.who.value = "";
    if (this.elements.what) this.elements.what.value = "";
    if (this.elements.vibe) this.elements.vibe.value = "";
    this.lastGenerated = null;
    this.setStatus("", false);

    if (this.elements.resultWrap) {
      this.elements.resultWrap.hidden = true;
      this.elements.resultWrap.classList.remove("wf-result--show");
    }

    this.clearGeneratedWord();
    this.hideMugPurchaseStep();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  observeNwfProductName();

  document.querySelectorAll('[id^="word-factory-"]').forEach(root => {
    new WordFactory(root);
  });
});
